import * as THREE from 'three'

class SpacecastRenderer extends THREE.WebGLRenderer {
  constructor(width = window.innerWidth, height = window.innerHeight) {
    super();
    this.setSize(width, height)
    this.setPixelRatio(devicePixelRatio)
  }
}

export default SpacecastRenderer;